import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { green } from "@mui/material/colors";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import { useToastMessage } from "@poseidon/ui/app/toasts/useToastMessage";
import { FullWidthField } from "@poseidon/ui/components/form/FullWidthField";
import Form from "@poseidon/ui/components/form/FullWidthForm";
import { Field, Formik } from "formik";
import { useMemo, useState } from "react";
import { useAuth } from "@poseidon/ui/components/AuthContext";
import { updateBoatHin } from "./api";

export const BoatWizardModal = ({ boat }) => {
  const [open, setOpen] = useState(!boat?.hin);
  const [loading, setLoading] = useState(false);
  const { setToast } = useToastMessage();
  const { setError } = useErrorMessage();
  const { user } = useAuth();

  const onSubmitHandler = async (values) => {
    setLoading(true);

    try {
      await updateBoatHin(values.hin, boat.id, user.uid);
      setToast("Successfully updated Boat");
      setOpen(false);
    } catch (error) {
      setError(error.message);
    }

    setLoading(false);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const initialValues = useMemo(() => ({ hin: boat.hin ?? "" }), [boat]);
  return (
    <Dialog open={open} onClose={handleClose}>
      <Formik initialValues={initialValues} onSubmit={onSubmitHandler}>
        <Form>
          <DialogTitle>Confirm Boat Details</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Insert the HIN number for the boat on this application
            </DialogContentText>
            <Field
              component={FullWidthField}
              name="hin"
              label="Hull Identification Number"
              margin="normal"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} disabled={loading}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              margin="normal"
              disabled={loading}
            >
              Submit
            </Button>
            {loading && (
              <CircularProgress
                size={24}
                sx={{
                  color: green[500],
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  marginTop: "-12px",
                  marginLeft: "-12px",
                }}
              />
            )}
          </DialogActions>
        </Form>
      </Formik>
    </Dialog>
  );
};
